import { type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';

interface AnimatedCardPortalProps {
  isExpanded: boolean;
  onClose: () => void;
  children: ReactNode;
}

export default function AnimatedCardPortal({
  isExpanded,
  onClose,
  children,
}: AnimatedCardPortalProps) {
  return (
    <>
      {/* Placeholder to maintain layout space when expanded */}
      {isExpanded && (
        <div
          className="card-shell mb-3"
          style={{
            visibility: 'hidden',
            height: 0,
            padding: 0,
            overflow: 'hidden',
            border: 'none',
          }}
        />
      )}

      {createPortal(
        <AnimatePresence>
          {isExpanded && (
            <>
              <motion.div
                key="card-backdrop"
                className="card-modal-backdrop"
                onClick={onClose}
                aria-hidden="true"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.2 }}
              />
              <motion.div
                key="card-container"
                className="card-portal-container"
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.95 }}
                transition={{ duration: 0.25, ease: 'easeOut' }}
              >
                {children}
              </motion.div>
            </>
          )}
        </AnimatePresence>,
        document.body
      )}

      {/* Render inline when not expanded */}
      {!isExpanded && children}
    </>
  );
}
